const defaultNames = {
  'processmaker-modeler-task': 'Form Task',
  'processmaker-modeler-manual-task': 'Manual Task',
  'processmaker-modeler-script-task': 'Script Task',
  'processmaker-modeler-call-activity': 'Sub Process',
  'processmaker-modeler-data-object' : 'Data Object',
  'processmaker-modeler-data-store': 'Data Store',
};

export default defaultNames;
